import { useTranslation } from 'react-i18next';
import { useEventMutation } from '@hooks/use-event-mutation';
import { useToast } from '@hooks/use-toast/use-toast';
import { useEventUIStore } from '@stores/event-ui-store';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';
import { type GroupCreateResponse } from './use-create-group';

const addOfferToGroupFetch = async (groupId: string, offerId: string) => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/offer-groups/${groupId}/offers`;

  return request({
    url,
    method: RequestMethod.POST,
    body: { offerId },
  });
};

export const useAddOfferToGroup = ({ eventId, offerName }: { eventId?: string; offerName?: string }) => {
  const { t } = useTranslation();
  const toast = useToast();
  return useEventMutation<GroupCreateResponse, RequestError, { groupId: string; offerId: string }>(
    [QUERY_KEYS.addOfferToGroup],
    async ({ groupId, offerId }) => addOfferToGroupFetch(groupId, offerId),
    {
      eventId,
      onSuccess: (_data, { groupId, offerId }) => {
        useEventUIStore.getState().setForceOpenGroupId(groupId);
        useEventUIStore.getState().setScrollTargetId(offerId);

        toast.push({
          title: t('admissionGroups:moveAdmissionToGroupSuccessMessage', {
            admissionName: offerName,
          }),
          text: '',
          type: 'success',
        });
      },
    }
  );
};
